const initialState = window.init_data;
const initList = initialState || [];
export default function initData(state = initList, action) {
  return state;
}